export default __webpack_public_path__ + "static/media/con_body02.814b0ca4.jpg";